import React from "react";

export default function InputError({ errors, name }) {
  return (
    <span className="text-danger">{errors[name] && errors[name].message}</span>
  );
}
